import { Injectable, Type } from '@angular/core';
import { FieldFactory } from '../field-factory.interface';
import * as fields from '../../models/settings/settings-fields-index';

import { FieldDataInterface } from '../../models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from '../../models/settings/settings-custom-form-field-data.class';
import * as fieldComponents from '../../components/fields/multiple-tag-selector-v1/multiple-tag-selector-v1-index';

@Injectable({
    providedIn: 'root'
})
export class MultipleTagSelectorV1FieldFactory implements FieldFactory {
    constructor(){}
    type: string = 'multiple-tag-selector-v1';
    menuTitle: string = "Multiple Tag Selector";
    deprecated: boolean = false;


    /**
      * 
      * @param field the object data of the field
      * @returns MultipleTagSelectorV1Field instance that extends SettingsCustomFormFieldData
     */
    createFillFormFieldData(field?: FieldDataInterface): SettingsCustomFormFieldData {
        // if (field) {
        //     return new fields.MultipleTagSelectorV1Field(this.type, field);
        // }
        // else {
            return new fields.SettingsMultipleTagSelectorV1Field(this.type, 0);
        // }
    }

    createSettingsFormField(position: number) : SettingsCustomFormFieldData {
        return new fields.SettingsMultipleTagSelectorV1Field(this.type, position);
    }

    deserializeSettingsFormField(field: FieldDataInterface) : SettingsCustomFormFieldData {
        const f =  new fields.SettingsMultipleTagSelectorV1Field(field.type, field.position);
        return f.deserialize(field);
    }

    getSettingsComponentType(): Type<fieldComponents.SettingsMultipleTagSelectorV1FieldComponent> {
        return fieldComponents.SettingsMultipleTagSelectorV1FieldComponent;
    }

    getFillComponentType(): Type<fieldComponents.FillMultipleTagSelectorV1FieldComponent> {
        return fieldComponents.FillMultipleTagSelectorV1FieldComponent;
    }

    getViewComponentType(): Type<fieldComponents.ViewMultipleTagSelectorV1FieldComponent> {
        return fieldComponents.ViewMultipleTagSelectorV1FieldComponent;
    }
}

